export default function getCurrencyList() {
    const requestOptions = {
        method: 'GET',
        // headers: { 'Content-Type': 'application/json' },
    };
    return fetch('/api/getCurrencyList',requestOptions).then((response) => response.json())
}